<template>
  <div class="bq-page" :class="{ 'bq-wireless-page': isMobile }">
    <banner
      class="bq-banner"
      type="horizontal"
      :cover="banner.cover"
      :mcover="banner.mcover"
    >
      <div class="bq-banner-content" slot="content">
        <h3 class="bq-banner-headline">{{ banner.title }}</h3>
        <div class="bq-banner-text" v-if="!isMobile">
          <p v-for="(item, index) in banner.content" :key="index">
            {{ item.text }}
          </p>
        </div>
        <!-- <div class="bq-banner-text" v-if="isMobile">
          {{mobileText}}
        </div> -->
        <div class="bq-banner-header">
          <img
            class="bq-banner-alipay"
            :src="banner.alipay.url"
            :alt="banner.alipay.text"
          />
          <div class="bq-banner-line"></div>
          <img
            class="bq-banner-brush"
            :src="banner.brush.url"
            :alt="banner.brush.text"
          />
          <img
            class="bq-banner-img"
            :src="banner.contact.url"
            :alt="banner.contact.text"
            @click="jumpContact"
          />
        </div>
      </div>
    </banner>

    <!--产品功能-->
    <box class="bq-box-product bq-row" :title="productData.title" id="product">
      <div class="bq-box-wrap">
        <ul class="bq-box-list">
          <li
            class="bq-box-item"
            v-for="(item, index) in productData.moduleData"
            :key="index"
          >
            <div class="bq-box-pic">
              <img :src="item.imgUrl" alt="item.title" />
            </div>
            <h3>{{ item.title }}</h3>
          </li>
        </ul>
      </div>
    </box>

    <!--产品优势-->
    <box
      class="bq-box-advantage"
      :title="advantage.title"
      :color="color"
      id="advantage"
    >
      <div class="bq-adv-content bq-row">
        <ul class="bq-adv-list" v-if="!isMobile">
          <li
            class="bq-adv-item"
            v-for="(item, index) in advantage.moduleData"
            :key="index"
          >
            <img :src="item.img" :alt="item.title" class="bq-adv-img" />
            <div>
              <h4 class="bq-adv-title">{{ item.title }}</h4>
              <p class="bq-adv-text">{{ item.text }}</p>
            </div>
          </li>
        </ul>

        <!--mobile-->
        <ul class="bq-adv-list" v-else>
          <li
            class="bq-adv-item"
            v-for="(item, index) in advantage.mobileModuleData"
            :key="index"
          >
            <img :src="item.img" :alt="item.title" class="bq-adv-img" />
            <div>
              <h4 class="bq-adv-title">{{ item.title }}</h4>
              <p class="bq-adv-text">{{ item.text }}</p>
            </div>
          </li>
        </ul>
      </div>
    </box>

    <!--基于蚂蚁金服金融级人脸识别能力-->
    <box class="bq-box-ident" :title="identity.title" id="ident">
      <div class="bq-idt-content bq-row">
        <ul class="bq-idt-list">
          <li
            class="bq-idt-item"
            v-for="(item, index) in identity.moduleData"
            :key="index"
          >
            <banner
              class="bq-idt-banner"
              type="horizontal"
              :cover="item.img"
              :mcover="item.mImg"
            >
              <h4 class="bq-idt-title" slot="content">{{ item.title }}</h4>
              <div class="bq-idt-line" slot="content"></div>
              <p class="bq-idt-text" slot="content">{{ item.text }}</p>
            </banner>
          </li>
        </ul>
      </div>
    </box>

    <!--客户案例-->
    <box class="bq-box-case" :title="caseData.title" id="case">
      <div class="bq-case-content bq-row">
        <ul class="bq-case-list">
          <li
            class="bq-case-item"
            v-for="(item, index) in caseData.moduleData"
            :key="index"
          >
            <img :src="item.img" :alt="item.title" class="bq-case-img" />
          </li>
        </ul>
        <div class="bq-case-text">
          <p
            class="bq-case-section"
            v-for="(item, index) in caseData.content"
            :key="index"
          >
            {{ item.text }}
          </p>
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
import Banner from '@/components/Banner';
import Box from '@/components/Box';

import {
  banner,
  productData,
  advantage,
  identity,
  caseData,
} from './productBrush.js';

import { isWirelessDevice } from '../../../utils/utils';

Vue.use(Swipe).use(SwipeItem);

export default {
  name: 'productBrush',

  components: {
    Box,
    Banner,
  },

  data() {
    return {
      isMobile: false,
      banner,
      productData,
      advantage,
      identity,
      caseData,
      color: '#fff',
      mobileText: '基于支付宝金融级人脸识别能力，实现全量人口的身份识别。',
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  methods: {
    jumpContact() {
      location.href = '/about?#contact';
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
